<div id="services-popup" class="common-popup-block-doc document-popup">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Añadir Documento</h2>
    </div>

    <div class="popoup-content">
        <form class="add-document-form" [formGroup]="empresaDocumentationFormGroup" role="form">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="form-wrap form-wrap-half">
                        <mat-label>Tipo</mat-label>
                        <mat-form-field class="display-flex m-b-5 example-form" floatLabel="always">
                            <mat-select formControlName="Tipo">
                                <mat-option *ngFor="let item of tipoDocEmpresaList" [value]="item.tipo">
                                    {{item.tipo}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-error
                            *ngIf="(empresaDocumentationFormGroup.get('Tipo').dirty || empresaDocumentationFormGroup.get('Tipo').touched ) && empresaDocumentationFormGroup.get('Tipo').invalid">
                            <span *ngIf="empresaDocumentationFormGroup.get('Tipo').errors.required"
                                class="validation-span ">Se debe especificar el tipo de documento</span>
                        </mat-error>
                    </div>
                    <div class="form-wrap form-five-width">
                        <mat-label>Fecha</mat-label>
                        <mat-form-field appearance="fill">
                            <input matInput [matDatepicker]="picker" formControlName="Fecha">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-error
                            *ngIf="(empresaDocumentationFormGroup.get('Fecha').dirty || empresaDocumentationFormGroup.get('Fecha').touched ) && empresaDocumentationFormGroup.get('Fecha').invalid">
                            <span *ngIf="empresaDocumentationFormGroup.get('Fecha').errors.required"
                                class="validation-span ">No se ha especificado la fecha</span>
                        </mat-error>
                    </div>
                </div>
                <div class="block-looper upload-area">
                    <div class="form-wrap form-wrap-full uploader">
                        <label>Documento</label>
                        <div class="uploadfilecontainer m-t-10 m-b-10" (click)="onclickFileInput(fileInput)"
                            appDragAndDrop (OnFileDropped)="uploadFile($event)">
                            <div class="spinner-tree" *ngIf="IsLoading == true">
                                <mat-progress-spinner class="m-auto spinner-loader" [diameter]="50" color="primary"
                                    mode="indeterminate">
                                </mat-progress-spinner>
                            </div>
                            <input hidden type="file" formControlName="Documento" #fileInput
                                (change)="uploadFile($event.target.files)"
                                   accept="{{FileFormatEnum.EmpresaController}}">
                                <!--accept="image/tiff,image/bmp,image/png,image/jpeg,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword">-->
                            <button mat-button color="primary">
                                <mat-icon class="f-s-19 upload_icon">cloud_upload</mat-icon>
                            </button>
                            <mat-error
                                *ngIf="(empresaDocumentationFormGroup.get('Documento').dirty || empresaDocumentationFormGroup.get('Documento').touched ) && empresaDocumentationFormGroup.get('Documento').invalid">
                                <span *ngIf="empresaDocumentationFormGroup.get('Documento').errors.required"
                                    class="validation-span">No se ha especificado el documento</span>
                            </mat-error>
                            <mat-error *ngIf="isInvalidDocumentType">
                                <span class="validation-span">Este tipo de document no se puede adjuntar</span>
                            </mat-error>
                        </div>
                    </div>
                    <div class="form-wrap form-wrap-half uploader">
                        <div class="files-list" *ngIf="file">
                            <p> {{ file }} </p>
                        </div>
                    </div>
                </div>
                <div class="block-looper">
                    <div class="form-wrap full-width">
                        <mat-label>Descripción</mat-label>
                        <textarea matInput formControlName="Descripcion"></textarea>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="popoup-footer">
        <button class="keep" #saveButton (click)="addDocument(saveButton)"><span
                class="mat-button-wrapper">Guardar</span></button>
        <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>